import React, { useEffect, useRef } from 'react'
import { useDevice } from 'device'
import { useEntry } from 'intersection-observer'
import { usePathname } from 'router'
import { useSubscription } from 'modules/subscription'
import { Icon } from 'components/dataDisplay'
import { WidthContainer, WidthContainerCompensator } from 'components/layout'

import { ApplicationStoreButtons, Basement, Nav, SocialNav } from 'compositions/Footer/components'


const Footer: React.FunctionComponent = () => {
  const { isMobile } = useDevice()

  const { subscription } = useSubscription()
  const pathname = usePathname()
  const initPathname = useRef(undefined)
  const [ ref, entry ] = useEntry({ observerProps: { threshold: 0.25 } })
  const isVisible = entry?.isIntersecting

  // TODO: Remove tracking when ab test CRO-226 is over
  useEffect(() => {
    // Fire event once per page view for active subscribers
    // check for scrollY to avoid firing while page is loading and footer is flashing in viewport
    if (isVisible && pathname !== initPathname.current && window.scrollY > 0 && subscription?.isActive) {
    // TODO: Uncomment the tracking when CRO-226 is launched
      // track('Footer display')
      initPathname.current = pathname
    }
  }, [ isVisible, pathname, subscription?.isActive ])


  if (isMobile) {
    return (
      <footer className="bg-black px-40 pb-32 pt-56" id="footer" ref={ref}>
        <Nav />
        <div className="mb-48 mt-36 text-center">
          <Icon name="other/scentbird-monogram" color="gold-30" />
        </div>
        <ApplicationStoreButtons className="mb-24" />
        <SocialNav />
        <WidthContainerCompensator>
          <Basement />
        </WidthContainerCompensator>
      </footer>
    )
  }

  return (
    <footer className="bg-black pb-32 pt-72" id="footer" ref={ref}>
      <WidthContainer size={944}>
        <Nav />
        <div className="mt-48 flex items-center justify-center">
          <Icon className="mr-80" name="other/scentbird-monogram" color="gold-30" />
          <ApplicationStoreButtons className="mr-12" />
          <SocialNav />
        </div>
        <Basement />
      </WidthContainer>
    </footer>
  )
}


export default Footer
